<template>
  <div class="cases">
    <!-- 导航栏 -->
    <header class="navbar">
      <div class="container" style="max-width: 100%;">
        <div class="logo">
          <img src="/hhwl.png" alt="北京和合网链科技有限公司" />
          <span>北京和合网链科技有限公司</span>
        </div>
        <nav class="nav-links">
          <router-link to="/" class="nav-link">首页</router-link>
          <router-link to="/health-detection" class="nav-link">健康检测</router-link>
          <router-link to="/health-management" class="nav-link">健康管理</router-link>
          <router-link to="/conditioning-service" class="nav-link">调理服务</router-link>
          <router-link to="/expert-team" class="nav-link">专家团队</router-link>
          <router-link to="/news" class="nav-link">行业资讯</router-link>
          <router-link to="/cases" class="nav-link" style="color: #3498db;">成功案例</router-link>
          <router-link to="/appointment-service" class="nav-link">预约服务</router-link>
        </nav>
        <div class="user-actions" style="width: 414.34px;"></div>
      </div>
    </header>

    <!-- 去掉面包屑导航 -->

    <!-- 主要内容 -->
    <main class="cases-main" style="padding-bottom: 60px;">
      <div class="container">
        <!-- 页面标题 -->
        <section class="page-header">
          <h1>成功案例</h1>
          <p>查看我们帮助患者获得健康改善的真实案例</p>
        </section>

        <!-- 案例分类 -->
        <section class="case-categories">
          <div class="category-tabs">
            <button 
              v-for="category in categories" 
              :key="category.id"
              :class="['category-tab', { active: currentCategory === category.id }]"
              @click="selectCategory(category.id)"
            >
              {{ category.name }}
            </button>
          </div>
        </section>

        <!-- 案例列表 -->
        <section class="case-list" >
          <div class="case-grid">
            <article 
              v-for="caseStudy in filteredCases" 
              :key="caseStudy.id"
              class="case-card"
              @click="viewCase(caseStudy)"
            >
              <div class="case-image">
                <div class="image-placeholder">{{ caseStudy.image }}</div>
                <div class="case-category">{{ caseStudy.category }}</div>
              </div>
              <div class="case-content">
                <h3 class="case-title">{{ caseStudy.title }}</h3>
                <p class="case-summary">{{ caseStudy.summary }}</p>
                <div class="case-meta">
                  <span class="date">{{ caseStudy.date }}</span>
                  <span class="client">{{ caseStudy.client }}</span>
                </div>
                <div class="case-tags">
                  <span v-for="tag in caseStudy.tags.slice(0, 3)" :key="tag" class="tag">{{ tag }}</span>
                </div>
              </div>
            </article>
          </div>

          <!-- 分页 -->
          <div class="pagination">
            <el-pagination
              background
              layout="prev, pager, next"
              :current-page="currentPage"
              :page-size="pageSize"
              :total="totalCases"
              @current-change="handlePageChange"
            >
            </el-pagination>
          </div>
        </section>
      </div>
    </main>

    <!-- 底部 -->
     <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-info">
            <h3>北京和合网链科技有限公司</h3>
            <p>专注健康科技，守护您的健康</p>
            <div class="contact-info">
              <p><i class="el-icon-location"></i> 地址：北京市丰台区南三环西路91号院1号楼14层1单元1706</p>
              <p><i class="el-icon-phone"></i> 电话：15383753755</p>
              <p><i class="el-icon-message"></i> 邮箱：james@tssen.com</p>
            </div>
          </div>
          <div class="footer-links-group">
            <div class="footer-links">
              <h4>快速导航</h4>
              <a href="#home">首页</a>
              <a href="#about">关于我们</a>
              <a href="#services">服务介绍</a>
              <a href="#contact">联系我们</a>
            </div>
            <div class="footer-services">
              <h4>服务项目</h4>
              <a href="#">健康检测</a>
              <a href="#">专家咨询</a>
              <a href="#">健康管理</a>
              <a href="#">调理服务</a>
            </div>
            <div class="footer-social">
              <h4>关于我们</h4>
              <div class="social-icons">
                <a href="#" class="social-icon"><i class="el-icon-message-solid"></i> 官方客服</a>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-bottom">
          <div class="copyright">
            <p style="font-size: 12px;" @click=" window.open('https://beian.miit.gov.cn/', '_blank', 'noopener noreferrer');">© 2026 北京和合网链科技发展有限公司 版权所有</p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'CaseList',
  data() {
    return {
      phone:null,
      currentCategory: 'all',
      currentPage: 1,
      pageSize: 9,
      categories: [
        { id: 'all', name: '全部案例' },
        { id: 'chronic', name: '慢性病调理' },
        { id: 'quantum', name: '量子调理' },
        { id: 'rehabilitation', name: '康复治疗' },
        { id: 'prevention', name: '疾病预防' },
        { id: 'health', name: '健康管理' }
      ],
      allCases: [
        {
          id: 1,
          title: '慢性疲劳综合征患者的量子健康调理成功案例',
          category: '慢性病调理',
          date: '2025-03-15',
          client: '张女士',
          summary: '通过量子健康检测和个性化调理方案，成功帮助一位长期受慢性疲劳综合征困扰的患者恢复健康活力，重获生活质量。',
          image: '🏆',
          tags: ['慢性疲劳', '量子调理', '个性化方案', '成功康复']
        },
        {
          id: 2,
          title: '量子能量疗法改善失眠症状的临床案例',
          category: '量子调理',
          date: '2025-03-10',
          client: '李先生',
          summary: '运用量子能量调理技术，结合个性化作息指导，帮助严重失眠患者恢复正常睡眠模式，提升生活质量。',
          image: '😴',
          tags: ['失眠治疗', '量子能量', '睡眠改善', '无创疗法']
        },
        {
          id: 3,
          title: '高血压患者的综合健康管理方案',
          category: '健康管理',
          date: '2026-03-05',
          client: '王先生',
          summary: '通过健康检测、营养指导、运动处方等综合干预，帮助高血压患者稳定血压，减少药物依赖。',
          image: '❤️',
          tags: ['高血压', '健康管理', '生活方式', '血压控制']
        },
        {
          id: 4,
          title: '颈椎病康复治疗的创新方法应用',
          category: '康复治疗',
          date: '2025-02-28',
          client: '赵女士',
          summary: '结合传统康复理疗与现代量子技术，为颈椎病患者提供全方位康复方案，显著改善症状。',
          image: '👩‍⚕️',
          tags: ['颈椎病', '康复治疗', '量子技术', '疼痛缓解']
        },
        {
          id: 5,
          title: '糖尿病前期干预的成功实践',
          category: '疾病预防',
          date: '2025-02-20',
          client: '刘先生',
          summary: '通过早期健康检测和针对性干预，成功帮助糖尿病前期患者逆转病情发展，避免进展为糖尿病。',
          image: '🩺',
          tags: ['糖尿病前期', '疾病预防', '早期干预', '健康逆转']
        },
        {
          id: 6,
          title: '儿童过敏体质的量子调理案例',
          category: '慢性病调理',
          date: '2025-02-15',
          client: '小明',
          summary: '采用温和的量子调理方法，结合营养指导，成功改善儿童过敏体质，减少过敏发作频率。',
          image: '👶',
          tags: ['儿童过敏', '量子调理', '营养指导', '体质改善']
        },
        {
          id: 7,
          title: '亚健康状态的综合调理方案',
          category: '健康管理',
          date: '2026-02-10',
          client: '陈女士',
          summary: '针对亚健康状态制定个性化调理方案，包括能量平衡、营养补充、运动指导等，全面改善身体状况。',
          image: '⚖️',
          tags: ['亚健康', '综合调理', '能量平衡', '健康提升']
        },
        {
          id: 8,
          title: '慢性胃炎的量子康复治疗',
          category: '慢性病调理',
          date: '2026-02-05',
          client: '孙先生',
          summary: '运用量子康复技术结合中医调理，帮助慢性胃炎患者修复胃黏膜，缓解症状，改善消化功能。',
          image: '🤰',
          tags: ['慢性胃炎', '量子康复', '中医调理', '消化改善']
        },
        {
          id: 9,
          title: '职场压力综合征的健康管理',
          category: '健康管理',
          date: '2026-01-30',
          client: '周女士',
          summary: '针对职场高压人群制定综合健康管理方案，包括压力管理、能量调理、作息调整等。',
          image: '💼',
          tags: ['职场压力', '压力管理', '能量调理', '作息调整']
        },
        {
          id: 10,
          title: '老年人骨关节病的康复案例',
          category: '康复治疗',
          date: '2025-01-25',
          client: '吴大爷',
          summary: '采用量子康复技术结合传统理疗，帮助老年骨关节病患者缓解疼痛，改善关节功能。',
          image: '🦴',
          tags: ['骨关节病', '老年康复', '量子技术', '疼痛管理']
        },
        {
          id: 11,
          title: '儿童注意力缺陷的综合干预',
          category: '康复治疗',
          date: '2026-01-20',
          client: '小华',
          summary: '通过量子调理、行为训练、营养指导等综合干预，改善儿童注意力缺陷，提升学习能力。',
          image: '🧠',
          tags: ['注意力缺陷', '儿童康复', '行为训练', '学习能力']
        },
        {
          id: 12,
          title: '代谢综合征的预防性健康管理',
          category: '疾病预防',
          date: '2026-01-15',
          client: '郑先生',
          summary: '通过早期健康检测和预防性干预，帮助代谢综合征患者改善各项指标，预防并发症。',
          image: '🔬',
          tags: ['代谢综合征', '疾病预防', '早期检测', '健康管理']
        }
      ]
    }
  },
  computed: {
    filteredCases() {
      let filtered = this.allCases
      
      // 按分类筛选
      if (this.currentCategory !== 'all') {
        const categoryMap = {
          'chronic': '慢性病调理',
          'quantum': '量子调理',
          'rehabilitation': '康复治疗',
          'prevention': '疾病预防',
          'health': '健康管理'
        }
        filtered = filtered.filter(caseStudy => caseStudy.category === categoryMap[this.currentCategory])
      }
      
      // 分页
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return filtered.slice(start, end)
    },
    totalCases() {
      let filtered = this.allCases
      
      if (this.currentCategory !== 'all') {
        const categoryMap = {
          'chronic': '慢性病调理',
          'quantum': '量子调理',
          'rehabilitation': '康复治疗',
          'prevention': '疾病预防',
          'health': '健康管理'
        }
        filtered = filtered.filter(caseStudy => caseStudy.category === categoryMap[this.currentCategory])
      }
      
      return filtered.length
    }
  },
  methods: {
    handleFeedBack() {
      this.$message.info('结果反馈功能')
    },
    handleReservationConditioning() {
      this.$message.info('查看预约功能')
    },
    reservationPromptClick() {
      this.$message.info('预约状态查询功能')
    },
    showPdf() {
      this.$message.info('检测结果功能')
    },
    selectCategory(categoryId) {
      this.currentCategory = categoryId
      this.currentPage = 1
    },
    handlePageChange(page) {
      this.currentPage = page
    },
    viewCase(caseStudy) {
      this.$router.push({
        path: '/case-detail',
        query: { id: caseStudy.id }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/* 导航栏样式 */
.navbar {
  background: white;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
  padding: 0 20px;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  max-width: 1200px;
  margin: 0 auto;
}

.logo {
  width: 414.34px;
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  font-weight: bold;
  color: #2c3e50;
  
  img {
    height: 40px;
    margin-right: 8px;
  }
}

.nav-links {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex: 1;
  flex-wrap: wrap;
  padding: 0.5rem 1rem;
  align-items: center;
  
  a, .nav-link {
    color: #2c3e50;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.3s ease;
    padding: 0.5rem 0;
    position: relative;
    white-space: nowrap;
    font-size: 0.95rem;
    cursor: pointer;
    
    &:hover,
    &.active,
    &.router-link-exact-active {
      color: #3498db;
    }
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 2px;
      background-color: #3498db;
      transition: width 0.3s ease;
    }
    
    &:hover::after,
    &.active::after {
      width: 100%;
    }
    
    &.btn-accent {
      background-color: #3498db;
      color: white;
      padding: 0.6rem 1.8rem;
      border-radius: 25px;
      font-weight: 600;
      box-shadow: 0 2px 8px rgba(52, 152, 219, 0.3);
      
      &:hover {
        background-color: #2980b9;
        color: white;
        box-shadow: 0 4px 12px rgba(41, 128, 185, 0.4);
        transform: translateY(-1px);
      }
      
      &::after {
        display: none;
      }
    }
  }
}

.user-actions {
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-left: auto;
}

.user-actions .login-btn {
  margin-left: auto;
}

.nav-btn {
  background: none;
  border: none;
  color: #2c3e50;
  cursor: pointer;
  font-weight: 500;
  transition: color 0.3s ease;
  
  &:hover {
    color: #3498db;
  }
}

.login-btn {
  background-color: #3498db;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  
  &:hover {
    background-color: #2980b9;
    color: white;
  }
}

/* 通用容器样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* 页面标题 */
.page-header {
  text-align: center;
  margin: 3rem 0;
}

.page-header h1 {
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 1rem;
}

.page-header p {
  font-size: 1.1rem;
  color: #666;
}

/* 分类标签 */
.case-categories {
  margin-bottom: 2rem;
}

.category-tabs {
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.category-tab {
  padding: 0.8rem 1.5rem;
  border: 2px solid #e9ecef;
  background: white;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  font-weight: 500;
}

.category-tab:hover {
  border-color: #1890FF;
  color: #1890FF;
}

.category-tab.active {
  background: #1890FF;
  border-color: #1890FF;
  color: white;
}

/* 案例列表 */
.case-main {
  min-height: 60vh;
  margin-bottom: 4rem;
}

.case-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 2rem;
  margin-bottom: 3rem;
}

.case-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  cursor: pointer;
}

.case-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0,0,0,0.15);
}

.case-image {
  position: relative;
  height: 200px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.image-placeholder {
  font-size: 3rem;
  opacity: 0.8;
}

.case-category {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: rgba(255,255,255,0.9);
  padding: 0.3rem 0.8rem;
  border-radius: 15px;
  font-size: 0.8rem;
  font-weight: 500;
  color: #1890FF;
}

.case-content {
  padding: 1.5rem;
}

.case-title {
  font-size: 1.1rem;
  color: #333;
  margin-bottom: 0.8rem;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.case-summary {
  color: #666;
  font-size: 0.9rem;
  line-height: 1.5;
  margin-bottom: 1rem;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.case-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  font-size: 0.8rem;
  color: #999;
}

.case-tags {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.tag {
  background: #f0f2f5;
  color: #666;
  padding: 0.2rem 0.6rem;
  border-radius: 10px;
  font-size: 0.75rem;
}

/* 分页 */
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 3rem;
}

/* 底部样式 */
.footer {
  background-color: #263238;
  color: white;
  padding: 3rem 0 1rem;
  
  .footer-content {
    display: grid;
    grid-template-columns: 0.4fr 0.6fr;
    gap: 3rem;
    margin-bottom: 2rem;
  }
  
  .footer-links-group {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
  }
  
  .footer-info h3 {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
    color: #fff;
  }
  
  .footer-info p {
    margin-bottom: 0.8rem;
    color: rgba(255, 255, 255, 0.8);
  }
  
  .contact-info {
    margin-top: 1rem;
  }
  
  .contact-info p {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.9rem;
  }
  
  .footer-links, .footer-services, .footer-social {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  
  .footer-links h4, .footer-services h4, .footer-social h4 {
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
    color: #fff;
    position: relative;
    padding-bottom: 8px;
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 40px;
      height: 2px;
      background-color: #3498db;
    }
  }
  
  .footer-links a, .footer-services a, .footer-social a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    transition: all 0.3s ease;
    font-size: 0.9rem;
    
    &:hover {
      color: #3498db;
      padding-left: 5px;
    }
  }
  
  .social-icons {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
  }
  
  .social-icon {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .footer-bottom {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding-top: 1rem;
    text-align: center;
  }
  
  .copyright {
    opacity: 0.8;
  }
  
  .copyright p {
    margin: 0;
    font-size: 12px;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .navbar .container {
    flex-direction: column;
    gap: 1rem;
  }

  .nav-links {
    display: none;
  }

  .page-header h1 {
    font-size: 2rem;
  }

  .case-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .category-tabs {
    gap: 0.5rem;
  }

  .category-tab {
    padding: 0.6rem 1rem;
    font-size: 0.8rem;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .footer-links-group {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}
</style>